import React from 'react'

const FilterButton = ({ toggleFilterPopup, filterApplied }) => {
  return (
    <div
      className={`filter-btn d-lg-none`}
      role="presentation"
      onClick={() => toggleFilterPopup(true)}
    >
      <span className={`icon icon-filter-dark-i`} />
      {filterApplied && <span className="filter-indicator" />}
    </div>
  )
}

export default FilterButton